import { render, staticRenderFns } from "./GotoTop.vue?vue&type=template&id=37b487e4&"
import script from "./GotoTop.vue?vue&type=script&lang=js&"
export * from "./GotoTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports